export const ANON_ID_KEY = 'ajs_anonymous_id';

export interface IVariantResult<TPayload = unknown> {
  key?: string;
  payload?: TPayload;
}

/** Shape of the client instance provided via AMPLITUDE_EXPERIMENT_CLIENT (avoids importing Node-only package). */
export interface IExperimentClientInstance {
  fetchV2: (
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Amplitude API contract
    user: { device_id: string; },
    opts: { flagKeys: string[]; }
  ) => Promise<Record<string, IVariantResult<unknown>>>;
}

/** Constructor options for the experiment client (matches @amplitude/experiment-node-server). */
export interface IExperimentClientOptions {
  serverUrl: string;
  fetchTimeoutMillis: number;
  fetchRetries: number;
  fetchRetryBackoffMinMillis: number;
  fetchRetryTimeoutMillis: number;
}

/** Constructor type for the client provided via AMPLITUDE_EXPERIMENT_CLIENT. */
export type ExperimentClientConstructor = new (
  deploymentKey: string,
  options: IExperimentClientOptions
) => IExperimentClientInstance;

/** Amplitude Experiment API base URL (Sondermind proxy). */
export const AMPLITUDE_SERVER_URL = 'https://amplitude.sondermind.com';

/** Timeout for each fetch to Amplitude. Kept low so SSR render does not block too long on flag evaluation. */
export const FETCH_TIMEOUT_MILLIS = 1500;
/** Number of retries after a failed fetch. Balances reliability with keeping SSR response time bounded. */
export const FETCH_RETRIES = 2;
/** No delay before first retry; subsequent retries use exponential backoff. */
export const FETCH_RETRY_BACKOFF_MIN_MILLIS = 0;
/** Max time allowed for the entire retry sequence. */
export const FETCH_RETRY_TIMEOUT_MILLIS = 1500;
